import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';

import { ApiService } from '../../Services/api.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-platform',
  imports: [CommonModule, RouterModule],
  templateUrl: './platform.component.html',
  styleUrl: './platform.component.css'
})
export class PlatformComponent {
  title(title: any) {
      throw new Error('Method not implemented.');
  }
  @ViewChild('closeModal') closeModal: any;

  private numberOfPlatforms: number = 23;
  isValid: boolean = false;

  private timeoutModal: any
  private timeoutModalTime: number = 10000;
  loading: boolean = true;
  year: any;
  version: string = environment.version;

  numberOfPages: any
  firstLines: any = []
  numberOfFirstLines: number = 1

  lineList: any = []
  lineListToTrim: any = []
  lineStart: number = 0
  lineStartToShow: number = 0

  numberOfLines: number = 3
  listLinesToshow: any = []
  trimTimePerLines: any //change in trimLines()

  listPage: number = 0;
  pageNumber: any

  hour:any 
  private previousHour: string = ''
  private nextHour: string = ''

  error: any = false;

  currentDate: Date = new Date()

  conection: boolean = false
  private server: any
  rotate: any = 'false'

  returnButton: Boolean = false

  private oldPage: any
  private oldLineStart: any

  private timeOut1:any
  private timeOut2:any

  private translations = [
    {"id":19, "operator": "ANDRADE VOYAGES", "operatorName": "Andrade Voyages"},
    {"id":12, "operator": "ANPIAN", "operatorName": "Anpian"},
    {"id":24, "operator": "AVE MOBILIDADE", "operatorName": "Ave Mobilidade"},
    {"id":1, "operator": "AVIC", "operatorName": "AVIC"},
    {"id":30, "operator": "BARCA EXPRESS", "operatorName": "Barca Express"},
    {"id":17, "operator": "BARQUENSE", "operatorName": "Barquense"},
    {"id":25, "operator": "BLABLACAR", "operatorName": "BlaBlaCar"},
    {"id":4, "operator": "EBA", "operatorName": "Getbus"},
    {"id":5, "operator": "EHGeres", "operatorName": "Hotéis do Gerês"},
    {"id":2, "operator": "FLIXBUS", "operatorName": "FlixBus"},
    {"id":10, "operator": "GETBUS", "operatorName": "GetBus"},
    {"id":27, "operator": "GIPSYY", "operatorName": "Gipsyy"},
    {"id":14, "operator": "GIROMUNDO", "operatorName": "Giromundo"},
    {"id":9, "operator": "INTERNORTE", "operatorName": "Internorte"},
    {"id":20, "operator": "LAZARA", "operatorName": "Lazara"},
    {"id":28, "operator": "MINHO BUS", "operatorName": "Minho Bus"},
    {"id":22, "operator": "MOB. CAVADO", "operatorName": "Cávado Mobilidade"},
    {"id":29, "operator": "MOOVE", "operatorName": "Moove"},
    {"id":8, "operator": "REDM", "operatorName": "Transdev REDM"},
    {"id":3, "operator": "RNE", "operatorName": "Rede Expressos"},
    {"id":13, "operator": "RODOMINHO", "operatorName": "Rodominho"},
    {"id":23, "operator": "TRANSDEV & AVIC", "operatorName": "Transdev & AVIC Lda."},
    {"id":11, "operator": "TRANSDEV NORTE", "operatorName": "Transdev Norte"},
    {"id":16, "operator": "TURISTICO", "operatorName": "Turístico"},
    {"id":7, "operator": "VERDE MINHO", "operatorName": "VerdeMinho"}
  ]

  public platform: any;
  public trimLinesInterval: any;

  public selectedLine: string = '';
  private selectedOperator: string = '';

  private loadingTimeout: any;
  private hideLineTimeout: any;
  private loadingTimeIntoLines: number = 300;
  private loadingTimeInLines: number = 7000;
  private loadingTimeOutLines: number = 200;

  constructor(
    private api:ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private location: Location
  )
  {

  }

  ngOnInit(){

    this.checkConection();
    setInterval(() => {
      this.checkConection();
    },30000);

    this.notifyKuma();
    setInterval(() => {
      this.notifyKuma();
    },300000);

    setTimeout(() => {
      this.GetParams();

      setTimeout(() => {
        this.CurrentTime();
        setInterval(() => {
          this.CurrentTime();
        },1000);
      }, 1000);

    },14000)

    /*
    if(this.rotate=='false'){
      setInterval(() => {
        if(this.error == false){
          this.updateSchedule();
        }
      },60000);
    }
    */
  }

  GetParams(){
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.server = queryParams.get('server')
    });

    if(this.server == 'true'){
      this.activatedRoute.queryParamMap.subscribe(queryParams => {
        this.platform= queryParams.get('platform')}
      );
      if(this.platform == ""){
        this.platform = undefined;
      }

     this.updateSchedule();

    } else {
      this.api.getPlatform().subscribe((data: any)=>{
        this.platform = data.platform
        this.updateSchedule();
      })
    }

    this.isValid = this.platform == undefined || (this.platform > 0 && this.platform <= this.numberOfPlatforms)

    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.rotate = queryParams.get('rotate')
    });
  }

  checkConection(){
    this.api.checkConection(this.platform).subscribe(
        (data:any)=>{
          this.conection=true
        },
        (error: any) => {
          this.conection=false
        }
      )
  }

  notifyKuma(){
    if (this.platform == undefined || this.platform == '') {
      return;
    }
    this.api.notifyKuma(this.platform).subscribe(
        (data:any)=>{
        },
        (error: any) => {
        }
      )
  }

  updateSchedule() {
    if(this.lineList==0 || this.hour > this.nextHour){

      this.api.getSchedule(this.server, this.platform, this.selectedLine, this.selectedOperator).subscribe(
        (data:any)=>{
          this.error = false
          this.firstLines = []
          this.lineList = []
          this.listLinesToshow = []
          this.numberOfPlatforms

          data.results.forEach((element: any, index: number) => {
            index
            let op = this.translations.find(op => op.id == element.id_operator);

            let opName = op != undefined ? op['operatorName'] : element.operator;

            let line = {
              line: element.line,
              operatorOriginal: element.operator,
              destination: element.line == '' ? element.destination : element.line + ' - ' + element.destination,
              observation: element.observation,
              operator: opName,
              time: element.time,
              platform: element.platform
            }

            if(index < this.numberOfFirstLines){
              this.firstLines.push(line)
              this.nextHour = '00:00';//this.firstLines[0].time;
            } else {
              this.lineList.push(line)
            }        
          });

          this.trimLines();
        },
        (error: any) => {
          this.error = true;

            setTimeout(() => {
              this.GetParams();
            }, 300000);
            
        })

    } else {
      if(this.rotate){
        this.trimLines();
      }
    }
  }

  showLine(line: string, operator: string) {
    if(this.selectedLine == '' && this.selectedOperator == '' && line != '' && operator != '') {
      this.loading = true;
      this.selectedLine = line;
      this.selectedOperator = operator;

      this.loadingTimeout = setTimeout(() => {
        this.updateSchedule();
      }, this.loadingTimeIntoLines);

      this.hideLineTimeout = setTimeout(() => {
        this.hideLine()
      }, this.loadingTimeInLines);
    }
  }

  hideLine() {
    this.loading = true;
    clearTimeout(this.loadingTimeout);
    clearTimeout(this.hideLineTimeout);
    setTimeout(() => {
        this.selectedLine = '';
        this.selectedOperator = '';
        this.updateSchedule();
      }, this.loadingTimeOutLines);
  }

  trimLines(){
    this.listLinesToshow = this.lineList.slice(this.lineStart, this.lineStart + this.numberOfLines)
    this.lineStartToShow = this.lineStart + this.listLinesToshow.length
    if(this.rotate=='true'){
      this.numberOfPages = Math.ceil(this.lineList.length/this.numberOfLines)
      this.lineStart = this.lineStart + this.numberOfLines

      if(this.listLinesToshow.length <=2 ){
        this.trimTimePerLines = 10000;
      } else {
        this.trimTimePerLines = 5000 * this.numberOfLines;
      }

      if(this.lineStart >= this.lineList.length){
        this.listPage++;

        this.lineStart = 0;

        this.timeOut2 = setTimeout(() => {
          this.listPage = 0;
          this.updateSchedule()
        }, this.trimTimePerLines);

      } else {
        this.listPage++;

        this.timeOut1 = setTimeout(() => {
          this.trimLines()
        }, this.trimTimePerLines);

      }
    }
    this.loading = false
  }

  numSequence(n: number): Array<number> {
    let arr = Array.from({length: n}, (_,i)=>  i+1)

    return arr;
  }

  CurrentTime() {
    this.year = new Date().getFullYear()
    const FHour: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    };
    this.currentDate = new Date();

    this.hour = this.currentDate.toLocaleTimeString(undefined, FHour);
    
    if (this.hour != this.previousHour) {
      this.updateSchedule();
      this.previousHour = this.hour;
    }
  }

  showPlatform(n: any){
    this.returnButton = !this.returnButton;

    if(this.returnButton){
      this.oldLineStart = this.lineStart
      this.oldPage = this.listPage
    }

    this.lineList = []
    this.platform = n;

    this.updateSchedule()

    this.lineStart = 0
    this.listPage = 0

    window.clearTimeout(this.timeOut1)
    window.clearTimeout(this.timeOut2)

    if(n == undefined){
      n = "";
      this.listPage = this.oldPage;
      this.lineStart = this.oldLineStart
    }

    this.location.replaceState('/?server=' + this.server + '&platform=' + n);
  }

  changeToPage(n: any){
    this.lineStart = ( n * this.numberOfLines ) - this.numberOfLines
    this.listLinesToshow = this.lineList.slice(this.lineStart, this.lineStart + this.numberOfLines)
    this.pageNumber = n
    this.listPage = this.pageNumber - 1;

    window.clearTimeout(this.timeOut1)
    window.clearTimeout(this.timeOut2)

    this.timeOut1=0
    this.timeOut2=0

    this.trimLines()
  }

  showModal(){
    window.clearTimeout(this.timeoutModal);

    this.timeoutModal = setTimeout(() => {
        this.closeModal.nativeElement.click();
    }, this.timeoutModalTime);
  }
}
